import { Helmet } from 'react-helmet'

interface FacebookProps {
  url: string
  type?: string
  title: string
  description: string
  image: string
  imageAlt?: string
  siteName?: string
}
function Facebook({ url, type, title, description, image, imageAlt, siteName }: FacebookProps) {
  return (
    <Helmet>
      {type && <meta property="og:type" content={type} />}
      {url && <meta property="og:url" content={url} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      {image && imageAlt && <meta property="og:image:alt" content={imageAlt} />}
      {siteName && <meta property="og:site_name" content={siteName} />}
    </Helmet>
  )
}

export default Facebook
